module.exports = __webpack_public_path__ + "img/construct_a_bridge.f4281cda.jpg";